module.exports = __webpack_public_path__ + "static/boty-opt-868cdac02adfe15b2e85dc5b62868d9c.jpg";